module.exports = __webpack_public_path__ + "img/43.938ce92.jpg";